/**
 * KRA Photo Journal – useKeyboard Hook
 * Attaches global keyboard listeners; returns a cleanup function.
 */

import { useEffect } from "react";

type KeyHandler = (e: KeyboardEvent) => void;

export function useKeyboard(handlers: Record<string, KeyHandler>) {
  useEffect(() => {
    const handle = (e: KeyboardEvent) => {
      const fn = handlers[e.key];
      if (fn) fn(e);
    };
    window.addEventListener("keydown", handle);
    return () => window.removeEventListener("keydown", handle);
  }, [handlers]);
}
